import React, { Fragment, useEffect } from 'react';
import { Link } from 'react-router-dom';
import punycode from 'punycode/';
import { Title, Description } from './old/Base';
import { S, mobile } from 'src/lib/util';
import { auth } from 'src/lib/api';
import { useM } from 'src/lib/hooks';
import { A } from '../A';
import { Dangerous } from '../individual/Dangerous';
import { SponsorList } from '../individual/sponsors';
import Donoboard from 'src/pages/donoboard';
import { HalfLine } from '../Info';

export const Highlights = () => {
  const [{user:viewer}] = auth.use()
  const profile_link = useM(viewer, () => viewer ? `u/${viewer}` : 'profile')

  useEffect(() => {
    const handleMessage = (e) => {
      if (e.origin === 'https://embed.gallery' && e.data.type === 'navigate') {
        window.location.href = e.data.url;
      }
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [])

  return <div id="highlights" style={S(`
  white-space: pre-line;
  display: flex; flex-direction: column; align-items: flex-start;
  gap: .5em;
  `)}>
    <div className='column'>
      {/* <span className='section-title'>word games (<A href='https://freshman.dev/fight-me'>fight me</A>) & more (<A href='/search'>search</A>)</span> */}

      <span className='section-title'>word games (<A href='https://freshman.dev/fight-me'>fight me</A>) & more (<A href='/search'>search</A>, <A href='/web-app-store'>apps</A>)</span>

      {/* <span>free word games & more</span> */}
      {/* <span>free word games & more: <A href='https://freshman.dev/fight-me'>fight me</A></span> */}
      {/* <span>enjoy? <A href='/about'>donate $2/mo</A></span> */}
    </div>
    <HalfLine />
    {/* <span>top 1</span>
    <A href='/light'>bar.chat (better twitter)</A>
    <HalfLine /> */}
    {true ? <>
      <span className='section-title'>top / new</span>
      <A href='https://logcal.app'>logcal.app (a social diary)</A>
      <A href='https://i-try-to-save-the-world-every-day.proj.host/'>i try to save the world every day (real)</A>
      <A href='https://webcast.social'>webcast.social (tiny web radio)</A>
      {/* <A href='https://minnow.social'>minnow.social (minimal personal websites)</A> */}
      <A href='https://iii.social'>iii.social (the Indie Internet Index)</A>
      {/* <A href='https://freshman.dev/greeter'>/greeter (social diary)</A> */}
      <A href='https://pangaea.social'>pangaea🌎social (local social network)</A>
      <A href='/lettercomb'>lettercomb (best word game imo)</A>
      <HalfLine />
      {mobile && 0 ? null : <>
        <span className='section-title'>more</span>
        <div>
          <A href='/letterpress'>letterpress</A> <A href='/wordbase'>wordbase</A> (more word games)
        </div>
        <A href='https://bitspace.freshman.dev'>BITSPACE (8-person space-battle arena)</A>
        <A href='https://p057.co'>p057.co (upload → URL)</A>
        <A href='https://embed.gallery'>embed.gallery (personal site widgets)</A>
        <A href='https://yxorp.app'>yxorp.app (personal site reverse proxy)</A>
        <A href='https://fuckingdonate.co'>fuckingdonate.co (tip jar)</A>
        <A href='https://sheet.social'>sheet.social (standup org tool)</A>
        {/* <A href='/wordle/leaderboard'>Wordle bot leaderboard (300+ bots)</A> */}
        {/* <A href='https://scoreboard.earth'>scoreboard.earth (rate anything)</A> */}
        {/* <A href='/light'>bar.chat (better twitter)</A> */}
        {/* <A href='https://friend-l.ink'>friend-l.ink (friend-making)</A>/ */}
        {/* <iframe src="https://embed.gallery/insert/68fd2d0497e209025fb1a938" frameBorder="0" style={{transform: 'scale(0.67)', transformOrigin: 'left top', marginBottom: '-23px', borderRadius: '0', border: 'none', width: '140px', height: '70px'}}></iframe> */}
        {/* <A href='/fishbowl'>/fishbowl (party game for 6-18)</A> */}
        {/* <A href='/matchbox'>/matchbox (joycon couch game)</A> */}
        {/* <A href='/raw/stream'>stream (microblog)</A> */}
        {/* <A href='/twitter/install'>Twitter blue Threads icon</A> */}
        {/* <A href='/itly'>/itly (smaller iMessage previews)</A> */}
        {/* <A href='/tap'>/tap (habit tracker)</A> */}
        {/* <HalfLine /> */}
      </>}
      {/* <span>new</span>
      <A href='https://not-an-asshole.com'>not-an-asshole.com (public ranking)</A>
      <A href='https://art-m.art'>art-m.art (spotify for art)</A>
      <A href='https://work-on.club/top'>work-on.club (share what ur working on)</A> */}
      {/* <A href='https://freshman.dev/petals'>/petals (new word game)</A> */}
      {/* <A href='/vibe'>/vibe (map of 24hr pics)</A> */}
      {/* <A href='/list-picker'>/list-picker (picks random menu item)</A> */}
      {/* <A href='/emoji-banner'>/emoji-banner (create twitter header)</A> */}
      {/* <A href='/stream-pledge'>/stream-pledge (get livestreaming)</A> */}
      {/* <A href='/running'>/running (get faster)</A> */}
      {/* <A href='/light'>/light (text-only twitter)</A> */}
      {/* <A href='/rent-splitter'>/rent-splitter (assign rooms fairly)</A> */}
      {/* <A tab='/radio'>radio</A> */}
      {/* <A href='/twitter/install'>/twitter (twitter blue Threads icon)</A> */}
      {/* <A href='/not-linkedin'>/not-linkedin (kill LinkedIn)</A> */}
      {/* <HalfLine /> */}
      {/* <span>finally</span> */}
      {/* <A href='https://freshman.dev/developer-program'>developer program (learn to code)</A> */}
      {/* <span>or</span> */}
      {/* <A href='/search'>something else? (open search)</A> */}
    </> : <>
      <A href='/lettercomb'>lettercomb (best word game imo)</A>
      <A href='/letterpress'>letterpress (also best word game)</A>
      <A href='/wordbase'>wordbase (word game i hate ugh)</A>
      <A href='/greeter'>greeter (social diary + AI)</A>
      <HalfLine />
      <A href='/wordle/leaderboard'>wordle bot leaderboard (300+ bots)</A>
      <A href='/fishbowl'>fishbowl (party game for 6-18)</A>
      <A href='/matchbox'>matchbox (joycon couch game)</A>
      <A href='/dinder'>dinder (tinder for dinner recipes)</A>
      <span>
        <A href='/pico-packet'>pico-packet</A> / <A href='https://github.com/cfreshman/pico-fi'>pico-fi</A> (Pico W)
      </span>
      <A href='/raw/river'>my river (microblog)</A>
      <A href='/pea-rice-explainer'>pea-rice (cheap green protein)</A>
      <HalfLine />
      <A href='https://freshman.dev/business'>business summary (Google Docs)</A>
      <A href='/search'>something else? (open search)</A>
    </>}

    <style>{`
      #highlights :is(img, iframe) {
        border-radius: 13px;
        width: 100%;
        // border: 1px solid #000;
        // // margin: 2px;
        // margin: 2px 0;
        // box-shadow: 0 0 0 2px currentcolor;

        border: 1px solid #fff;
        border-radius: 14px;
      }
      #highlights img {
        // border: 1px solid #fff;
        filter: contrast(1.5) brightness(.9);
      }
      #highlights {
        font-size: 12.5px;
      }
      #highlights .section-title {
        // font-size: 14px;
      }
    `}</style>
  </div>
}